// Vuex records module actions
import { API } from '@/config';

import { FILL_PROJECT_DETAILS } from './mutations-types';

export default {

  async updateProject(context, params) {
    try {
      await API.patch('/client/project/updateProject', { ...params });
    } catch (err) {
      console.log(err);
    }
  },

  async getProjectDetails({ commit }, project) {
    try {
      const params = { project };
      const { record, total } = (await API.get('/client/project/getDetails', { params })).data.data;
      commit(FILL_PROJECT_DETAILS, { record, total });
    } catch (e) {
      console.log(e);
    }
  },

  async getHelpdeskNumbersForProject(context, project) {
    try {
      const params = { project };
      const response = (await API.get('/project/getHelpdeskNumbersForProject', { params })).data.data.help_desk_numbers;
      return response;
    } catch (e) {
      console.log(e);
      return 0;
    }
  },
};
